module.exports = "/assets/data/8863bbe6cb60da68420cfa357e757224-CA7.data.json";